/**
 * @module geo/components
 *
 */

import {ExtensionType} from '../types/extensions';
import {BottomPanelExtension, BottomPanelExtensionProperties} from '../types/extensions/bottom.panel';

import {Component} from './component';

/**
 * Represents the panel wich contains the tabular view in PRO canvas
 * @since 2.1.0
 */
export class BottomPanel extends Component {
  defaultExtensionType = ExtensionType.BOTTOM_PANEL;
  defaultExtensionProperties = {
    visible: true,
    closable: false,
    hideHeader: false,
    softHide: false,
    order: 0
  };
  public buildExtension(properties: BottomPanelExtensionProperties):
      BottomPanelExtension {
    const type = this.defaultExtensionType;
    const props = {...this.defaultExtensionProperties};
    Object.assign(props, properties);

    return {type, properties: props} as BottomPanelExtension;
  }
}
